<script>
  import { linkResolver } from "./prismic";
  import { browser } from "$app/environment";
  export let page;
  export let nav;
  export let item;
  export let hover;
  export let path;
  export let activeNav;
  export let subnav;

  page.subnav = (page?.subnav || []).filter(({ page }) => !!page?._meta?.uid);

  $: hasSubnav = page.subnav?.length > 0;

  const click = (e) => {
    // if (hasSubnav) {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   if (subnav?._meta.uid === page._meta.uid) subnav = null;
    //   else {
    //     subnav = page;
    //   }
    // } else {
    nav = false;
    //}
  };
</script>

<a
  sveltekit:prefetch
  on:click={click}
  on:mouseover={(e) => {
    hover(e.currentTarget);
    if (hasSubnav) {
      subnav = page;
    }
  }}
  on:mouseout={(e) => {
    hover(activeNav);
    const snav = document.getElementById("subnav");
    if (hasSubnav && (!snav || !snav.contains(e.relatedTarget))) {
      subnav = null;
    }
  }}
  on:focus
  on:blur
  bind:this={item}
  class="relative mb-4 landscape:mb-2 lg:ml-4 lg:mb-0 border-b-3 py-1 lg:py-6 px-4 border-transparent hover:border-orange lg:hover:border-transparent {browser
    ? 'transition lg:transition-none duration-300'
    : ''} leading-none {path === linkResolver(page._meta)
    ? 'bg-orange lg:bg-transparent'
    : ''}"
  href={linkResolver(page._meta)}
  ><span class="border-t-3 border-transparent block"
    >{page?.title?.[0]?.text}</span
  ></a
>
{#if hasSubnav}
  <div class="block lg:hidden -mt-4 mb-4">
    <a
      href={linkResolver(page._meta)}
      class="subnav-link"
      on:click={() => (nav = false)}>{page.overview_label || "Übersicht"}</a
    >
    {#each ["col_1", "col_2", "col_3"] as column}
      {#if page[column]}
        <span class=" text-white/60 text-xl px-8 font-light"
          >{page[column]}</span
        >

        {#each page.subnav as { page, title_overwrite, column: pageColumn }}
          {#if page?._meta?.uid && column === pageColumn}
            <a
              href={linkResolver(page?._meta)}
              class="subnav-link"
              on:click={() => (nav = false)}
            >
              {title_overwrite || page?.title?.[0]?.text}
            </a>
          {/if}
        {/each}
      {/if}
    {/each}
  </div>
{/if}

<style lang="postcss">
  .subnav-link {
    @apply block normal-case text-lg font-sans px-8 font-light;
  }
</style>
